import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { confirmLeadForward } from "@/services/gitchaReachService";
import "./LeadForwardConfirm.scss";

export const outcomeOf = (response) => {
  const body = response?.data ?? response;
  if (body?.status === "confirmed") return { state: "confirmed", email: body.email };
  if (body?.status === "unavailable") return { state: "unavailable" };
  return { state: "expired" };
};

const LeadForwardConfirm = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const started = useRef(false);
  const [outcome, setOutcome] = useState({ state: token ? "ready" : "expired" });

  useEffect(() => {
    document.title = "Confirm lead forwarding | Gitcha";
  }, []);

  // Confirming only on a click keeps mail scanners that open links from switching forwarding on.
  const confirm = () => {
    if (!token || started.current) return;
    started.current = true;
    setOutcome({ state: "working" });
    confirmLeadForward(token)
      .then((response) => setOutcome(outcomeOf(response)))
      .catch((error) => setOutcome(outcomeOf(error?.response)));
  };

  return (
    <main className="lead-forward-confirm">
      <div className="lead-forward-confirm__card" role="status" aria-busy={outcome.state === "working"}>
        {outcome.state === "ready" ? (
          <>
            <h1>Turn on lead&nbsp;forwarding?</h1>
            <p className="lead-forward-confirm__body">
              Gitcha will copy each new lead to the email address you set up in Settings, Notifications.
            </p>
            <button type="button" className="btn btn-primary" onClick={confirm}>
              Turn on forwarding
            </button>
          </>
        ) : null}
        {outcome.state === "working" ? <p className="lead-forward-confirm__body">Confirming…</p> : null}
        {outcome.state === "confirmed" ? (
          <>
            <h1>Lead forwarding is&nbsp;on</h1>
            <p className="lead-forward-confirm__body">
              Gitcha now copies each new lead to {outcome.email}. You can close this&nbsp;page.
            </p>
          </>
        ) : null}
        {outcome.state === "expired" ? (
          <>
            <h1>This link has&nbsp;expired</h1>
            <p className="lead-forward-confirm__body">
              Links work once and for 24 hours. Ask the agent to send a new one from Settings, Notifications.
            </p>
          </>
        ) : null}
        {outcome.state === "unavailable" ? (
          <>
            <h1>We couldn't confirm right&nbsp;now</h1>
            <p className="lead-forward-confirm__body">Try the link again in a few&nbsp;minutes.</p>
          </>
        ) : null}
      </div>
    </main>
  );
};

export default LeadForwardConfirm;
